import { isEmpty } from 'bold-ui'
import { resolveName } from 'components/form'
import { MetaPath } from 'util/metaPath'
import { ErrorObject, range } from 'util/validation'

import { UnidadeForcaMuscularSelectModel } from './UnidadeForcaMuscularSelectField'

interface ForcaMuscularMaoModel {
  valorForcaMuscMaoDireita?: string | number
  unidadeForcaMuscMaoDireita?: UnidadeForcaMuscularSelectModel
  valorForcaMuscMaoEsquerda?: string | number
  unidadeForcaMuscMaoEsquerda?: UnidadeForcaMuscularSelectModel
}

const PREENCHER_VALOR_E_UNIDADE_FORCA_ERROR_MESSAGE = 'É necessário preencher o valor e a unidade de força.'

export function validateForcaMuscularMao(
  values: ForcaMuscularMaoModel | undefined,
  errors: ErrorObject<ForcaMuscularMaoModel>,
  valorPath: MetaPath<string | number>,
  unidadePath: MetaPath<UnidadeForcaMuscularSelectModel>
): void {
  const valorKey = resolveName(valorPath)
  const unidadeKey = resolveName(unidadePath)

  const hasValor = !isEmpty(values?.[valorKey])
  const hasUnidade = !isEmpty(values?.[unidadeKey])

  if (!hasValor && hasUnidade) {
    errors[valorKey] = PREENCHER_VALOR_E_UNIDADE_FORCA_ERROR_MESSAGE
  }

  if (hasValor && !hasUnidade) {
    errors[unidadeKey] = PREENCHER_VALOR_E_UNIDADE_FORCA_ERROR_MESSAGE
  }
}

export const validateForcaMuscularMaoRange = range(0, 100)
